<template>
	<div class="page_ordinary">
		<el-form class="form_ordinary" label-width="100px">


			<div class="big_tit" style="margin:0">货物信息</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="货物名称" style="width:388px">
					<el-select class="el_inner_width" v-model="form.cargo_name" @change="cargo_name_change" allow-create filterable placeholder="请输入货物名称">
						<el-option
							v-for="(item,index) in used_cargo_names"
							:key="index"
							:label="item"
							:value="item"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="el_form_item" label="货物类型" style="width:588px">
					<el-select class="el_inner_width" v-model="form.cargo_type" clearable>
						<el-option v-for="(item,index) in cargo_type" :key="index" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="货重(吨)" style="width:388px">
					<el-input class="el_inner_width" type="number" v-model="form.cargo_weight" placeholder="不填表示面议" clearable></el-input>
				</el-form-item>
				<el-form-item class="el_form_item" label="体积(方)" style="width:588px">
					<el-input class="el_inner_width" type="number" v-model="form.cargo_volume" placeholder="不填表示面议" clearable></el-input>
				</el-form-item>
			</div>


			<div class="big_tit">装/卸货地信息</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="装货地" style="width:388px">
					<el-cascader class="el_inner_width" v-model="form.case_city" placeholder="装货地省市区" :options="cities" filterable></el-cascader>
				</el-form-item>
				<el-form-item class="el_form_item" label="装货地详情" style="width:588px">
					<el-input class="el_inner_width" v-model="form.case_addr" placeholder="请输入装货地详细地址" clearable>
						<el-button slot="append">地图</el-button>
					</el-input>
				</el-form-item>
			</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="卸货地" style="width:388px">
					<el-cascader class="el_inner_width" v-model="form.aim_city" placeholder="卸货地省市区" :options="cities" filterable></el-cascader>
				</el-form-item>
				<el-form-item class="el_form_item" label="卸货地详情" style="width:588px">
					<el-input class="el_inner_width" v-model="form.aim_addr" placeholder="请输入卸货地详细地址" clearable>
						<el-button slot="append">地图</el-button>
					</el-input>
				</el-form-item>
			</div>


			<div class="big_tit">运费相关 (说明: 如果不填运费则只能进行招投标, 如果填写运费可以直接抢单也可以指定也可以招投标)</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="运费(元)" style="width:388px">
					<el-input class="el_inner_width" type="number" v-model="form.freight_total" placeholder="请输入运费信息" clearable></el-input>
				</el-form-item>
				<el-form-item class="el_form_item" label="结算方式" style="width:588px">
					<el-select class="el_inner_width" v-model="form.settlement_type" clearable>
						<el-option label="按吨结算" value="1"></el-option>
						<el-option label="按方结算" value="2"></el-option>
						<el-option label="按趟结算" value="3"></el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="是否回程" style="width:388px">
					<el-select class="el_inner_width" v-model="form.is_need_return" clearable>
						<el-option label="需要回程" value="1"></el-option>
						<el-option label="不需要回程" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="el_form_item" label="运输距离" style="width:588px">
					<el-input class="el_inner_width" v-model="form.distance" type="number" placeholder="单位(公里), 非必填" clearable>
						<el-button slot="append">公里</el-button>
					</el-input>
				</el-form-item>
			</div>


			<div class="big_tit">装卸货地日期</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="装货日期" style="width:488px">
					<el-date-picker
						v-model="form.case_date"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					></el-date-picker>
				</el-form-item>
				<el-form-item class="el_form_item" label="卸货日期" style="width:488px">
					<el-date-picker
						v-model="form.aim_date"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					></el-date-picker>
				</el-form-item>
			</div>


			<div class="big_tit">发货人</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="货主电话" style="width:388px">
					<el-input class="el_inner_width" type="number" v-model="shipper_info.tel" placeholder="不填表示不指定" clearable>
						<el-button @click="shipper_info_ser" type="success" slot="append">查找</el-button>
					</el-input>
				</el-form-item>
				<el-form-item class="el_form_item" label="货主信息" style="width:588px">
					<el-input class="el_inner_width" v-model="shipper_info.info_text" :disabled="true" clearable>
						<el-button @click="shipper_info_clear" type="success" slot="append">清空</el-button>
					</el-input>
				</el-form-item>
			</div>


			<!-- <div class="big_tit">指定车主</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="车主电话" style="width:388px">
					<el-input class="el_inner_width" type="number" v-model="truck_owner.tel" placeholder="不填表示不指定" clearable>
						<el-button @click="truck_owner_ser" type="success" slot="append">查找</el-button>
					</el-input>
				</el-form-item>
				<el-form-item class="el_form_item" label="车主信息" style="width:588px">
					<el-input class="el_inner_width" v-model="truck_owner.name" :disabled="true" clearable>
						<el-button @click="truck_owner_clear" type="success" slot="append">清空</el-button>
					</el-input>
				</el-form-item>
			</div> -->


			<div class="big_tit">其他信息</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="上游单号" style="width:388px">
					<el-input class="el_inner_width" v-model="form.out_trade_num" placeholder="非必填, 请酌情使用" clearable></el-input>
				</el-form-item>
				<el-form-item class="el_form_item" label="组别编号" style="width:588px">
					<el-input class="el_inner_width" v-model="form.group1_num" placeholder="非必填, 请酌情使用" clearable></el-input>
				</el-form-item>
			</div>
			<div class="tab1_inner">
				<el-form-item class="el_form_item" label="车型要求" style="width:388px">
					<el-cascader class="el_inner_width" v-model="form.need_truck_type" placeholder="非必填" :options="truck_type" filterable></el-cascader>
				</el-form-item>
				<el-form-item class="el_form_item" label="运单备注" style="width:588px">
					<el-input class="el_inner_width" v-model="form.mark" placeholder="非必填, 请酌情使用" clearable></el-input>
				</el-form-item>
			</div>
		</el-form>

		<div class="bottom_btns">
			<el-button type="primary" @click="sub">提交订单</el-button>
			<el-button type="danger" @click="clear">清空数据</el-button>
		</div>
	</div>
</template>
<script>
	import {regionData,CodeToText,TextToCode} from 'element-china-area-data'
	import truck_type_handle from '@/my/_truck_type_handle.js'
	export default {
		data() {
			return {

				//表单
				form: {
					group1_num:'',//组别编号
					out_trade_num:'',//上游单号
					cargo_name:'',//货物名称
					cargo_type:'',//货物性质
					case_city:[],//装货地省市区
					case_addr:'',//装货地详情
					case_date:null,//装货时间
					aim_city:[],//卸货地省市区
					aim_addr:'',//卸货地详情
					aim_date:null,//卸货时间
					freight_total:null,//运费
					settlement_type:'3',//结算方式(0:未知,1:按吨数,2:按方数,3:按趟)
					is_need_return:'2',//是否回程(1:需要,2:不需要)
					distance:'',//运输距离(单位:公里)
					cargo_weight:'',//货物重量
					cargo_volume:'',//货物体积
					need_truck_type:null,//租用货车类型
					mark:'',//备注
				},

				//货主
				shipper_info:{
					tel:'',//货主电话
					info_text:'',//货主信息
					user_num:'',//货主用户编号
				},

				//车主
				truck_owner:{
					tel:'',//司机电话
					name:'',//司机姓名
					user_num:'',//司机用户编号
				},

				//城市联动数据
				cities:regionData,

				//货物类型
				cargo_type:[],

				//车型
				truck_type:[],

				//使用过的货物名称
				used_cargo_names:[],
			}
		},
		created() {

			//使用过的货物名称初始化
			this.set_used_cargo_name();

			//获取参数
			this.get_creat_para();

			//置入缓存数据(可能存在)
			this.set_buf_data();
		},
		methods: {

			//提交
			sub(){

				let post_data={
					mod:'truck_tord_real_time',
					ctr:'cargo_add_admin',
				};

				if(!this.shipper_info.user_num){//货主
					this.$my.other.msg({
						type:"warning",
						str:'缺少货主信息'
					});
					return;
				}else post_data.shipper_num=this.shipper_info.user_num

				if(!this.form.cargo_name.trim()){
					this.$my.other.msg({
						type:"warning",
						str:'缺少货物名称'
					});
					return;
				}else post_data.cargo_name=this.form.cargo_name.trim()

				if(!this.form.cargo_type.trim()){
					this.$my.other.msg({
						type:"warning",
						str:'缺少货物性质'
					});
					return;
				}else post_data.cargo_type=this.form.cargo_type.trim()

				if(this.$my.check.is_num(this.form.cargo_weight)&&this.form.cargo_weight>0){//货物重量
					post_data.cargo_weight=this.form.cargo_weight
				}

				if(this.$my.check.is_num(this.form.cargo_volume)&&this.form.cargo_volume>0){//货物体积
					post_data.cargo_volume=this.form.cargo_volume
				}

				let case_prov=CodeToText[this.form.case_city[0]];
				let case_city=CodeToText[this.form.case_city[1]];
				let case_county=CodeToText[this.form.case_city[2]];
				let aim_prov=CodeToText[this.form.aim_city[0]];
				let aim_city=CodeToText[this.form.aim_city[1]];
				let aim_county=CodeToText[this.form.aim_city[2]];

				if(!(case_prov&&case_city&&case_county)){
					this.$my.other.msg({
						type:"warning",
						str:'缺少装货地信息'
					});
					return;
				}else{
					post_data.case_prov=case_prov
					post_data.case_city=case_city
					post_data.case_county=case_county
				}

				if(!(aim_prov&&aim_city&&aim_county)){
					this.$my.other.msg({
						type:"warning",
						str:'缺少卸货地信息'
					});
					return;
				}else{
					post_data.aim_prov=aim_prov
					post_data.aim_city=aim_city
					post_data.aim_county=aim_county
				}

				if(this.form.case_addr.trim()){//发货地详细地址
					post_data.case_addr=this.form.case_addr.trim()
				}

				if(this.form.aim_addr.trim()){//卸货地详情
					post_data.aim_addr=this.form.aim_addr.trim()
				}

				if(this.form.case_date){//装货日期
					let case_date_start=this.form.case_date[0].getTime();
					let case_date_end=this.form.case_date[1].getTime();
					let now_time=new Date((new Date().setHours(0, 0, 0, 0))).getTime()
					if(case_date_start<now_time){
						this.$my.other.msg({
							type:"warning",
							str:'装货日期起点不能早于当前时间'
						});
						return;
					}
					post_data.case_date_start=(case_date_start/1000).toFixed(0)
					post_data.case_date_end=(case_date_end/1000).toFixed(0)
				}

				if(this.form.aim_date){//卸货日期
					let aim_date_start=this.form.aim_date[0].getTime();
					let aim_date_end=this.form.aim_date[1].getTime();
					let now_time=(new Date()).getTime()
					if(post_data.case_date_end&&aim_date_start<post_data.case_date_end){
						this.$my.other.msg({
							type:"warning",
							str:'卸货日期起点不能早于装货日期'
						});
						return;
					}else if(!post_data.case_date_end&&aim_date_start<now_time){
						this.$my.other.msg({
							type:"warning",
							str:'卸货日期起点不能早于当前时间'
						});
						return;
					}
					post_data.aim_date_start=(aim_date_start/1000).toFixed(0)
					post_data.aim_date_end=(aim_date_end/1000).toFixed(0)
				}

				if(this.form.need_truck_type){//租用货车类型
					post_data.need_truck_type=this.form.need_truck_type[0]
					post_data.need_truck_type2=this.form.need_truck_type[1]
				}

				if(this.form.group1_num.trim()){//组编号1(用户自定义打组)
					post_data.group1_num=this.form.group1_num.trim()
				}

				if(this.form.out_trade_num.trim()){//上游单号
					post_data.out_trade_num=this.form.out_trade_num.trim()
				}

				if(this.form.mark.trim()){//备注
					post_data.mark=this.form.mark.trim()
				}

				if(this.truck_owner.user_num){//车主

					//如果指定了车主,必须有运费
					if(!(this.$my.check.is_num(this.form.freight_total)&&this.form.freight_total>0)){//运费
						this.$my.other.msg({
							type:"warning",
							str:'如果指定了车主,必须填写运费'
						});
						return;
					}

					post_data.freight_total=this.form.freight_total
					post_data.truck_owner_num=this.truck_owner.user_num
				}else{

					if(this.$my.check.is_num(this.form.freight_total)&&this.form.freight_total>0){//运费
						post_data.freight_total=this.form.freight_total
					}
				}

				//货主与车主是否重合
				if(post_data.shipper_num==post_data.truck_owner_num){
					this.$my.other.msg({
						type:"warning",
						str:'货主与车主不能是同一人'
					});
					return;
				}

				//结算方式(0:未知,1:按吨数,2:按方数,3:按趟)
				post_data.settlement_type=this.form.settlement_type

				//是否回程(1:需要,2:不需要)
				post_data.is_need_return=this.form.is_need_return

				//运输距离(单位:公里)
				post_data.distance=this.form.distance

				//提交数据
				this.$my.net.req({
					data:post_data,
					callback:(data)=>{

						//如果指定了车主, 前往'待接单'
						if(post_data.truck_owner_num){

							//添加成功
							this.$my.other.confirm({
								content:"发货成功,是否前往待接单列表?",
								confirm:()=>{

									this.$router.push({
										path:'/pages/transit_real_time/tord_deal'
									});
								}
							});

						//如果没有指定车主, 前往'货源列表'
						}else{

							//添加成功
							this.$my.other.confirm({
								content:"发货成功,是否前往货源列表?",
								confirm:()=>{

									this.$router.push({
										path:'/pages/transit_real_time/cargo_list_admin'
									});
								}
							});
						}
					}
				});
			},

			//查找货主
			shipper_info_ser(){

				//格式判断
				if(!this.$my.check.is_tel(this.shipper_info.tel)){
					this.$my.other.msg({
						type:"warning",
						str:'货主电话号码格式有误'
					});
					return;
				}

				//读取数据
				this.$my.net.req({
					data:{
						mod:'app_user',
						ctr:'admin_list',
						tel:this.shipper_info.tel
					},
					callback:(data)=>{

						data=data.list[0];

						if(!data){
							this.$my.other.msg({
								type:"warning",
								str:'不存在的货主'
							});
							return;
						}

						if(data.name=='未实名'){//这里是为了兼容 翔达 的业务逻辑不能使用 real_status 进行判断
							this.$my.other.msg({
								type:"warning",
								str:'此用户未完成实名认证'
							});
							return;
						}

						this.shipper_info.user_num=data.user_num
						this.shipper_info.info_text=data.name+' / '+data.company_name
					}
				});
			},

			//清空货主信息
			shipper_info_clear(){
				this.shipper_info.tel=''
				this.shipper_info.info_text=''
				this.shipper_info.user_num=''
			},

			//查找司机
			truck_owner_ser(){

				//格式判断
				if(!this.$my.check.is_tel(this.truck_owner.tel)){
					this.$my.other.msg({
						type:"warning",
						str:'司机电话号码格式有误'
					});
					return;
				}

				//读取数据
				this.$my.net.req({
					data:{
						mod:'truck',
						ctr:'truck_owner_info',
						truck_owner_tel:this.truck_owner.tel
					},
					callback:(data)=>{

						if(data.name=='未实名'){
							this.$my.other.msg({
								type:"warning",
								str:'此用户未完成实名认证'
							});
							return;
						}

						let user_info=this.$my.cache.get("user_info");
						if(user_info.user_num==data.user_num){
							this.$my.other.msg({
								type:"warning",
								str:'不能指定自己'
							});
							return;
						}

						this.truck_owner.user_num=data.user_num
						this.truck_owner.name=data.name
					}
				});
			},

			//清空司机信息
			truck_owner_clear(){
				this.truck_owner.tel=''
				this.truck_owner.name=''
				this.truck_owner.user_num=''
			},

			//清空本页数据
			clear(){

				this.$my.other.confirm({
					content:"点击确定清空本页数据",
					confirm:()=>{

						//清空货源数据
						this.form.cargo_name="";
						this.form.cargo_type="";
						this.form.case_city=[];
						this.form.case_addr="";
						this.form.case_date=null;
						this.form.aim_city=[];
						this.form.aim_addr="";
						this.form.aim_date=null;
						this.form.freight_total="";
						this.form.settlement_type="3";
						this.form.is_need_return="2";
						this.form.distance="";
						this.form.cargo_weight="";
						this.form.cargo_volume="";
						this.form.mark="";

						//清空货主数据
						this.shipper_info_clear()

						//清空司机数据
						this.truck_owner_clear()
					}
				});
			},

			//置入缓存数据
			set_buf_data(){

				//尝试读取缓存
				let cargo_creat_buf=this.$my.cache.get('__cargo_creat_buf');
				if(this.$my.check.is_obj(cargo_creat_buf)){

					//复制
					cargo_creat_buf={...cargo_creat_buf};

					//置入数据
					this.form.cargo_name=cargo_creat_buf.cargo_name;
					this.form.cargo_type=cargo_creat_buf.cargo_type;
					this.form.case_addr=cargo_creat_buf.case_addr;
					this.form.aim_addr=cargo_creat_buf.aim_addr;
					this.form.freight_total=cargo_creat_buf.freight_total;
					this.form.cargo_weight=cargo_creat_buf.cargo_weight;
					this.form.cargo_volume=cargo_creat_buf.cargo_volume;
					this.form.mark=cargo_creat_buf.mark;

					//车主数据
					if(cargo_creat_buf.truck_info){
						this.truck_owner.tel=cargo_creat_buf.truck_info.tel
						this.truck_owner.name=cargo_creat_buf.truck_info.name
						this.truck_owner.user_num=cargo_creat_buf.truck_info.user_num
					}

					//特殊处理
					this.form.case_city=[
						TextToCode[cargo_creat_buf.case_prov].code,
						TextToCode[cargo_creat_buf.case_prov][cargo_creat_buf.case_city].code,
						TextToCode[cargo_creat_buf.case_prov][cargo_creat_buf.case_city][cargo_creat_buf.case_county].code,
					];
					if(cargo_creat_buf.case_date_start>0&&cargo_creat_buf.case_date_end>0){
						this.form.case_date=[
							new Date((cargo_creat_buf.case_date_start*1000).toFixed(0)),
							new Date((cargo_creat_buf.case_date_end*1000).toFixed(0)),
						];
					}
					this.form.aim_city=[
						TextToCode[cargo_creat_buf.aim_prov].code,
						TextToCode[cargo_creat_buf.aim_prov][cargo_creat_buf.aim_city].code,
						TextToCode[cargo_creat_buf.aim_prov][cargo_creat_buf.aim_city][cargo_creat_buf.aim_county].code,
					];
					if(cargo_creat_buf.aim_date_start>0&&cargo_creat_buf.aim_date_end>0){
						this.form.aim_date=[
							new Date((cargo_creat_buf.aim_date_start*1000).toFixed(0)),
							new Date((cargo_creat_buf.aim_date_end*1000).toFixed(0)),
						];
					}
					this.form.need_truck_type=[
						cargo_creat_buf.need_truck_type,
						cargo_creat_buf.need_truck_type2,
					];
				}
			},

			//获取创建参数
			get_creat_para(){

				//尝试从缓存中取出
				let creat_para=this.$my.cache.get('cargo_creat_page_creat_para');

				//如果取出成功
				if(creat_para){
					this.truck_type=creat_para.truck_type
					this.cargo_type=creat_para.cargo_type
					return
				}

				//如果取出失败,去服务器读取
				this.$my.net.req({
					data:{
						mod:'truck_tord_real_time',
						ctr:'cargo_creat_para'
					},
					callback:(data)=>{

						//格式化车型数据
						let truck_type=truck_type_handle.for_el_cascader(data.truck_type);

						//缓存之
						this.$my.cache.set({
							cargo_creat_page_creat_para:{
								truck_type:truck_type,
								cargo_type:data.cargo_type
							}
						});

						//置入
						this.truck_type=truck_type
						this.cargo_type=data.cargo_type
					}
				})
			},

			//使用过的货物名称初始化
			set_used_cargo_name(){
				let used_cargo_name=window.localStorage.getItem('cargo_creat_page_used_cargo_names');
				if(used_cargo_name){
					used_cargo_name=JSON.parse(used_cargo_name);
				}else used_cargo_name=[];
				this.used_cargo_names=[...used_cargo_name];
			},

			//货物名称输入
			cargo_name_change(){

				//查看此输入内容是否已收录
				let hasinputed=false;
				let used_cargo_names=[...this.used_cargo_names];
				for(var i in used_cargo_names){

					let item=used_cargo_names[i]

					//已收录,挪到第一位
					if(this.form.cargo_name==item){

						//删除原数组中对应的元素
						this.used_cargo_names.splice(i,1);

						//在原数组中新增此元素,并放到第一个未知
						this.used_cargo_names.unshift(this.form.cargo_name);

						//已收录
						hasinputed=true;
						break;
					}
				}

				//如果没有收录
				if(!hasinputed){

					//收入之
					this.used_cargo_names.unshift(this.form.cargo_name);
				}

				//保存到本地硬盘
				window.localStorage.setItem('cargo_creat_page_used_cargo_names',JSON.stringify(this.used_cargo_names))
			}
		}
	}
</script>
<style lang="scss" scoped>

	.el_form_item{
		margin: 0;
	}
	.big_tit{
		background-color: #eee;
		padding: 10px 20px;
		color: #666;
		font-weight: 600;
		font-size: 18px;
		margin-top: 20px;
	}
	.tab1_inner{
		padding: 15px 15px 0 15px;
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	.el_inner_width{
		width:94%;
	}

	.bottom_btns{
		text-align: center;
		position: absolute;
		bottom: 0px;
		width: 100%;
		padding: 15px 0;
		background-color: #fff;
		border-top: 1px solid #ccc;
	}

	.form_ordinary{
		height: calc(100% - 91px);
		padding: 10px 0;
		overflow-y:auto;
	}

	.page_ordinary{
		position:relative;
		height:100%;
	}

</style>